import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import config from '@/config';
let OrderPay = class OrderPay extends Vue {
    constructor() {
        super(...arguments);
        this.is_auto = true;
        this.errInfo = null;
        this.needReceiverId = false;
    }
    get icon() {
        if (this.is_auto) {
            return require('./images/icon_auto.png');
        }
        else {
            return require('./images/icon_success.png');
        }
    }
    async created() {
        if (this.$route.query.receiver_id &&
            typeof this.$route.query.receiver_id !== 'string') {
            if (Array.isArray([...this.$route.query.receiver_id])) {
                window.location.href = window.location.href.replace(/&receiver_id=\d+/, '');
                return;
            }
        }
        let info = this.$route.query.data;
        // let info: any = {
        //   is_auto: false,
        //   status_code: 'SUCCESS',
        //   cost: {
        //     amount: 256.73,
        //     left: 1742.27,
        //     goods: { name: '【英文原版绘本随机3本】', value: 259 },
        //     claimed_amount: 70.1,
        //   },
        // }
        this.costData = info.cost;
        if (!this.costData) {
            return this.$router.push({
                path: '/orderclaim',
                query: {
                    receiver_id: this.$route.query.receiver_id,
                },
            });
        }
        this.is_auto = info.is_auto;
        if (info.status_code != 'SUCCESS') {
            this.errInfo = info.message;
        }
        else {
            this.errInfo = null;
        }
        this.needReceiverId =
            Object.keys(this.costData.received_goods || {}).length > 0;
        this.judgeNeedReceiverId();
    }
    async judgeNeedReceiverId() {
        if (this.needReceiverId && this.$route.query.receiver_id) {
            this.$axios.post('/api/activity/h5Activity/anniversary8/collectClaimOrderAddress', {
                receiver_id: this.$route.query.receiver_id,
            });
        }
    }
    clickReturn() {
        this.$router.push({
            path: '/orderclaim',
        });
    }
    onClickBanner() {
        // window.location.href = 'http://t.yaledad.com/LJq?@521514682'
        window.location.href = 'http://t.yaledad.com/Twm?';
    }
    clickrecord() {
        this.$router.push({
            path: '/claimrecord',
            query: {},
        });
    }
    goAddress() {
        const origin = config.env === 'production'
            ? 'https://m.ivydad.com'
            : 'http://m.ivydad.com.cn';
        window.location.href = `${origin}/center/address/addressList?mode=select&redirect=${encodeURIComponent(location.href)}`;
    }
};
OrderPay = tslib_1.__decorate([
    Component({})
], OrderPay);
export default OrderPay;
